
import React from "react";
import HeroSection from "./HeroSection"; // Adjust path as needed
import BuyersAgentReviewSection from "./BuyersAgentReviewSection"; // Adjust path as needed
import LandingContent from "./LandingContent"

const NPCBookingLanding = () => {
  return (
    <div className="bg-white text-gray-900 font-sans">
      {/* Hero Section */}
      <HeroSection />
      <LandingContent />
       <BuyersAgentReviewSection />

      {/* Rest of the page content */}
      {/* Other sections go here */}
    </div>
  );
};

export default NPCBookingLanding;




// import React, { useMemo } from "react";
// // If you want an inline Calendly embed, install react-calendly or paste the inline widget below.
// // import { InlineWidget } from "react-calendly";
// import ToolsShowcase from "../ToolsShowCase"; // NOTE: ensure file name matches this exact casing

// // ----- Mock: replace with your API when ready -----
// const recentDrops = [
//   {
//     id: "wmr-104",
//     suburb: "Werribee VIC",
//     headline: "Dual‑living potential near station",
//     price: "$635k–$665k",
//     yield: "6.4% est.",
//     land: "612 sqm",
//     img: "/offmarket/werribee-104.jpg",
//     updatedAt: "Updated this week",
//   },
//   {
//     id: "frk-221",
//     suburb: "Frankston North VIC",
//     headline: "3BR + granny flat (co‑living ready)",
//     price: "$580k–$620k",
//     yield: "7.2% est.",
//     land: "536 sqm",
//     img: "/offmarket/frankston-221.jpg",
//     updatedAt: "Updated this week",
//   },
//   {
//     id: "ips-88",
//     suburb: "Ipswich QLD",
//     headline: "Rooming‑house conversion candidate",
//     price: "$540k–$560k",
//     yield: "8.1% est.",
//     land: "703 sqm",
//     img: "/offmarket/ipswich-88.jpg",
//     updatedAt: "New in the last 7 days",
//   },
// ];

// const Stat = ({ value, label }) => (
//   <div className="bg-white p-6 rounded-2xl shadow-sm border">
//     <div className="text-3xl font-extrabold text-[#da3e13]">{value}</div>
//     <p className="mt-1 text-sm text-gray-700">{label}</p>
//   </div>
// );

// const Badge = ({ children }) => (
//   <span className="inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium text-[#003366] border-[#003366]/20 bg-[#003366]/5">
//     {children}
//   </span>
// );

// const NPCBookingLanding = () => {
//   const monthSpots = useMemo(() => ({ total: 6, booked: 4 }), []); // tweak
//   const spotsLeft = monthSpots.total - monthSpots.booked;

//   return (
//     <div className="bg-white text-gray-900 font-sans">
//       {/* Sticky header CTA */}
//       <div className="sticky top-0 z-40 backdrop-blur bg-white/70 border-b">
//         <div className="mx-auto max-w-7xl px-4 py-2 flex items-center justify-between">
//           <div className="flex items-center gap-3">
//             <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse" />
//             <p className="text-sm text-[#003366] font-semibold">
//               New off‑market drops every week
//             </p>
//           </div>
//           <a
//             href="https://calendly.com/YOUR-CALENDLY-LINK"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="hidden sm:inline-block rounded-full bg-[#da3e13] px-4 py-2 text-white text-sm font-semibold hover:bg-[#b3320f]"
//           >
//             Book a Free Strategy Call
//           </a>
//         </div>
//       </div>

//       {/* Hero Section */}
//       <section className="bg-white pt-14 pb-8 px-6 text-center">
//         <div className="max-w-5xl mx-auto">
//           <h1 className="text-4xl md:text-5xl font-extrabold text-[#003366] leading-tight mb-6">
//             Stop Overpaying for Investment Properties & Missing Out on Huge Opportunities
//           </h1>
//           <div className="h-1.5 w-40 bg-[#fbb40b] rounded-full mx-auto mb-6" aria-hidden="true" />
//           <p className="text-[#003366]/90 text-lg md:text-xl max-w-3xl mx-auto mb-6">
//             Are you tired of competing with other investors in Melbourne's red-hot market? Don’t miss out on huge growth opportunities like we’ve seen in Perth & QLD — start securing exclusive off-market deals today.
//           </p>

//           <div className="text-[#003366]/90 text-lg mb-6">
//             <h3 className="font-semibold text-xl mb-3">The Problem You're Facing:</h3>
//             <ul className="list-disc list-inside text-sm">
//               <li>👉 Paying more than you should in a competitive market.</li>
//               <li>👉 Missing out on high-growth properties and watching them slip away.</li>
//               <li>👉 Lack of results despite talking to agents.</li>
//               <li>👉 Sales agents preferring to work with buyers’ agents, making it harder for you.</li>
//               <li>👉 Your opportunity cost is huge: If a $650k house grows by 15%, you could be losing around $97,500 over the next year. That’s $1,875 every week you wait!</li>
//             </ul>
//           </div>

//           <div className="text-[#003366]/90 text-lg mb-6">
//             <h3 className="font-semibold text-xl mb-3">The Solution:</h3>
//             <ul className="list-disc list-inside text-sm">
//               <li>💪 Build a strong network of sales agents who know and trust you.</li>
//               <li>💰 Win in a competitive market by getting access to exclusive off-market deals.</li>
//               <li>🔑 Get deals that you won't find anywhere else with Propsourcing™ — 50+ off-market properties sourced weekly!</li>
//               <li>📞 Stay connected with agents weekly, nurturing strong relationships to stay ahead.</li>
//               <li>✅ Use an expert buyers agent with a proven system to secure your next big deal.</li>
//             </ul>
//           </div>

//           {/* CTA with urgency */}
//           <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
//             <a
//               href="https://calendly.com/YOUR-CALENDLY-LINK"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center justify-center bg-[#da3e13] text-white px-6 py-3 rounded-xl text-lg font-semibold hover:bg-[#b3320f]"
//             >
//               Book Your Free Strategy Call Today
//             </a>
//             <span className="text-sm text-[#003366]/80">
//               Only {spotsLeft} of {monthSpots.total} spots left this month!
//             </span>
//           </div>

//           <p className="mt-3 text-xs text-gray-600">No obligation · 100% confidential</p>
//         </div>
//       </section>


//       {/* Tools Section (kept) */}
//       <ToolsShowcase />

//       {/* NEW: Recent Off‑Market Drops ("looks like recent and keeps changing every week") */}
//       <section className="py-12 px-6 md:px-10 bg-gray-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="flex items-end justify-between gap-4 mb-6">
//             <div>
//               <h2 className="text-2xl md:text-3xl font-bold text-[#003366]">
//                 Recent Off‑Market Drops
//               </h2>
//               <p className="text-sm text-gray-600">Curated weekly — examples below refresh as new stock appears.</p>
//             </div>
//             <div className="text-right">
//               <div className="text-xs text-gray-600">Last refreshed</div>
//               <div className="text-sm font-semibold">{new Date().toLocaleDateString()}</div>
//             </div>
//           </div>

//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {recentDrops.map((p) => (
//               <article key={p.id} className="group bg-white rounded-2xl border shadow-sm overflow-hidden">
//                 <div className="aspect-[16/10] bg-gray-100 overflow-hidden">
//                   <img src={p.img} alt={p.suburb} className="h-full w-full object-cover group-hover:scale-105 transition" />
//                 </div>
//                 <div className="p-4">
//                   <div className="flex items-center justify-between gap-2">
//                     <h3 className="font-semibold text-[#003366]">{p.suburb}</h3>
//                     <span className="text-xs text-green-700">{p.updatedAt}</span>
//                   </div>
//                   <p className="mt-1 text-sm text-gray-700">{p.headline}</p>
//                   <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
//                     <Badge>Guide: {p.price}</Badge>
//                     <Badge>Yield: {p.yield}</Badge>
//                     <Badge>Land: {p.land}</Badge>
//                   </div>
//                   <div className="mt-4 flex items-center justify-between">
//                     <a
//                       href="https://calendly.com/YOUR-CALENDLY-LINK"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-sm font-semibold text-[#da3e13] hover:underline"
//                     >
//                       Book to Access
//                     </a>
//                     <span className="text-[11px] text-gray-500">Details shared on call</span>
//                   </div>
//                 </div>
//               </article>
//             ))}
//           </div>

//           <div className="text-center mt-8">
//             <a
//               href="https://www.nationalpropertyconsultant.com.au/offmarket-properties"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center justify-center rounded-full border px-5 py-3 text-sm font-semibold text-[#003366] hover:bg-white"
//             >
//               See This Week's Full Drop List →
//             </a>
//             <p className="mt-2 text-xs text-gray-600">We never publish addresses publicly. We brief serious buyers 1:1.</p>
//           </div>
//         </div>
//       </section>

//       {/* 90‑Day Results (kept, styled) */}
//       <section className="py-12 px-6 md:px-20 bg-white text-center">
//         <h2 className="text-2xl md:text-3xl font-bold mb-6 text-[#003366]">In the Last 90 Days Alone…</h2>
//         <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
//           <Stat value="38" label="Off‑Market Properties Sourced" />
//           <Stat value="7.1%" label="Average Rental Yield" />
//           <Stat value="$42,000" label="Average Below‑Market Saving" />
//         </div>
//       </section>

//       {/* How it works + objections handling */}
//       <section className="py-12 px-6 md:px-10 bg-gray-50">
//         <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
//           <div className="bg-white rounded-2xl border p-6">
//             <h3 className="font-semibold text-[#003366] mb-2">1) Brief & Strategy</h3>
//             <p className="text-sm text-gray-700">We map your yield, budget and suburbs. SMSF or co‑living? We calibrate accordingly.</p>
//           </div>
//           <div className="bg-white rounded-2xl border p-6">
//             <h3 className="font-semibold text-[#003366] mb-2">2) Source & Vet</h3>
//             <p className="text-sm text-gray-700">Daily scans of our agent network + Propsourcing™ drops. We filter for cash‑flow and DD flags.</p>
//           </div>
//           <div className="bg-white rounded-2xl border p-6">
//             <h3 className="font-semibold text-[#003366] mb-2">3) Secure & Settle</h3>
//             <p className="text-sm text-gray-700">We negotiate, line up B&P, and hand you a clean, fast path to the deal.</p>
//           </div>
//         </div>
//       </section>

//       {/* Inline Calendly (option A). If you prefer a link only, keep the CTA buttons above. */}
//       <section className="py-12 px-6 md:px-20 bg-[#003366] text-white">
//         <div className="max-w-5xl mx-auto text-center">
//           <h2 className="text-2xl md:text-3xl font-bold mb-4">Ready to See This Week’s Off‑Markets?</h2>
//           <p className="mb-6 text-white/90">Grab a time below. We'll walk you through the live list and match options to your brief.</p>

//           {/* Option A: InlineWidget (uncomment if using react-calendly) */}
//           {/* <div className="rounded-2xl overflow-hidden bg-white"> */}
//           {/*   <InlineWidget url="https://calendly.com/YOUR-CALENDLY-LINK" styles={{ height: 700 }} /> */}
//           {/* </div> */}

//           {/* Option B: Native embed (no extra package): */}
//           <div className="rounded-2xl overflow-hidden bg-white">
//             <div className="calendly-inline-widget" data-url="https://calendly.com/YOUR-CALENDLY-LINK" style={{ minWidth: "320px", height: "700px" }} />
//           </div>
//           <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="py-6 text-center text-sm text-gray-500">
//         © {new Date().getFullYear()} NPC Buyers Agency · All Rights Reserved · Off‑market previews change weekly
//       </footer>
//     </div>
//   );
// };

// export default NPCBookingLanding;
